const mutations = {
    setPaymentModes(state, data) {
        state.paymentModeList = data;
    },
    setPaymentMode(state,data){
        state.paymentMode = data;
    },
    resetPaymentMode(state){
        state.paymentMode = {
            label :  ''
        }
    }
}

export default mutations;